import { Utils } from '../utils';
import { CustomUIEvent } from '../events';
export var RotateEventType;
(function (RotateEventType) {
    RotateEventType["Start"] = "rotatestart";
    RotateEventType["Rotate"] = "rotate";
    RotateEventType["End"] = "rotateend";
})(RotateEventType || (RotateEventType = {}));
export class RotateEventArgsClass {
    constructor(_builder) {
        this._builder = _builder;
    }
    get currentPosition() {
        return this._builder.currentPosition;
    }
    get rotation() {
        return this._builder.rotation;
    }
    get element() {
        return this._builder.element;
    }
    get center() {
        return this._builder.center;
    }
    static fromArgs(builder) {
        return new RotateEventArgsClass(Utils.extend({}, builder));
    }
}
export class RotateEvent extends CustomUIEvent {
    constructor(type, args, eventInit, evt) {
        super(type, args, eventInit, evt);
    }
}
//}
